var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartEssentialShoppingSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 30",
    id: "Layer_30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.52,13.59,63,13.39l-7.1,28H20.23l-8.86-32H1.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.83,
    cy: 52.17,
    r: 3.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.1,
    cy: 52.17,
    r: 3.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.65,
    x2: 58.29,
    y1: 32.1,
    y2: 32.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15,
    x2: 60.7,
    y1: 22.56,
    y2: 22.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.15,
    x2: 24.15,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    x2: 15.83,
    y1: 13.54,
    y2: 25.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.41,
    x2: 32.41,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.66,
    x2: 40.66,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 48.92,
    x2: 48.92,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.18,
    x2: 57.18,
    y1: 13.54,
    y2: 36.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.23,41.41V45.7a2.55,2.55,0,0,0,2.55,2.55H53.24"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEssentialShoppingSvgrepoCom);
export default __webpack_public_path__ + "static/media/cart-essential-shopping-svgrepo-com.c0b6cfb8fe197812d5d60abeab5e4df5.svg";
export { ForwardRef as ReactComponent };